import { gql } from "@apollo/client";

export const GET_BATCH = gql`
  query Batch($group: UUID!, $businessUnit: Int!) {
    group(group: $group, businessUnit: $businessUnit) {
      id
      animalsNumberCache
      averageDobInBatch
      category
      gendersInBatch
      numberOfUnidentifiedAnimalsInBatch
      isBatch
      targetWeight
      targetDate
      daysTillTarget
      avgDlwg
      timeOnFarm
      name
      animalType {
        id
        name
      }
      animalBreeds {
        id
      }
      summaryMetrics {
        femaleCount
        maleCount
        breedrCode
      }
    }
  }
`;

export const GET_GROUP = gql`
  query Group($group: UUID!, $businessUnit: Int!) {
    group(group: $group, businessUnit: $businessUnit) {
      id
      name
      targetWeight
      category
      animalType {
        id
        colour
        image
      }
      targetDate
      timeOnFarm
      minAge
      maxAge
      weightInfo {
        minWeight
        maxWeight
      }
      category
      minDaysOnFarm
      maxDaysOnFarm
      avgEstimatedWeight
      avgRecordedWeight
      avgDlwg
      daysTillTarget
      isBatch
      summaryMetrics {
        breedrCode
        animalsCount
        femaleCount
        maleCount
      }
      animals {
        id
      }
    }
  }
`;

export const GET_GROUPS_INFO = gql`
  query GroupsInfo($businessUnitId: Int, $animalTypeIds: [Int]) {
    groupsExtended(businessUnitId: $businessUnitId, animalTypeIds: $animalTypeIds) {
      groupsCount
      groups {
        id
        name
        isBatch
      }
    }
  }
`;

export const GET_GROUPS_COUNT = gql`
  query GetGroupsCount($businessUnitId: Int) {
    groupsExtended(businessUnitId: $businessUnitId) {
      groupsCount
    }
  }
`;
